import endOfSchoolYear from "../endOfSchoolYear";

const endOfLastSchoolYear = (date = new Date()) => {
  const schoolYear = endOfSchoolYear(date);

  // Subtract one year to the end date
  schoolYear.setMonth(schoolYear.getMonth() - 12);

  return schoolYear;
};

export default endOfLastSchoolYear;
